import * as yup from 'yup'

export const blankBuilding = () => ({
  created: new Date(),
  title: '',
  description: '',
  coordinates: [],
  hideExactCoordinates: false,
  address: {
    address1: '',
    address2: '',
    city: '',
    state: '',
    zip: null,
    country: '',
  },
  linkedServices: [],
  featuredImage: '',
  thumbnailImage: '',
  imageGallery: [],
  about: {
    summary: '',
    sections: [],
    checkInHour: 16,
    checkInMinute: 0,
    checkOutHour: 11,
    checkOutMinute: 0,
    registrationMessage: '',
    guestInstructions: [],
    guestCheckOutInstructions: [],
  },
  pricing: {
    baseRate: 0,
    deposit: 0,
    cleaning: 0,
    basicCleaning: 0,
    tax: 0,
    extraFees: [],
  },
  public: true,
})

export const buildingSchema = yup.object().shape({
  title: yup.string().required(),
  description: yup.string().required(),
  // coordinates: [longitude, latitude] make sure number is between -180 to 180 and -90 to 90
  coordinates: yup.array().of(yup.number().required()).length(2),
  hideExactCoordinates: yup.bool(),
  address: yup.object({
    address1: yup.string().required(),
    address2: yup.string(),
    city: yup.string().required(),
    state: yup.string().required(),
    // string or number
    // zip: yup.string().required(),
    zip: yup.number().required(),
    country: yup.string().required(),
  }),
  linkedServices: yup.array().of(yup.object().shape({
    linkedService: yup.string().required(),
    linkedServiceId: yup.string().required()
  })),
  featuredImage: yup.string().url(),
  thumbnailImage: yup.string().url(),
  imageGallery: yup.array().of(yup.object().shape({
    url: yup.string().url().required(),
    title: yup.string(),
    description: yup.string(),
    thumbUrl: yup.string().url()
  })),
  about: yup.object({
    summary: yup.string(),
    sections: yup.array().of(yup.object().shape({
      sectionId: yup.string().required(),
      sectionTitle: yup.string().required(),
      content: yup.string().required(),
      sectionImage: yup.string().nullable()
    })),
    checkInHour: yup.number().required(),
    checkInMinute: yup.number().required(),
    checkOutHour: yup.number().required(),
    checkOutMinute: yup.number().required(),
    registrationMessage: yup.string(),
    guestInstructions: yup.array().of(yup.object().shape({
      sectionId: yup.string().required(),
      sectionTitle: yup.string().required(),
      content: yup.string().required(),
      sectionImage: yup.string().nullable()
    })),
    guestCheckOutInstructions: yup.array().of(yup.object().shape({
      sectionId: yup.string().required(),
      sectionTitle: yup.string().required(),
      content: yup.string().required(),
      sectionImage: yup.string().nullable()
    })),
  }),
  pricing: yup.object({
    baseRate: yup.number().required(),
    deposit: yup.number().required(),
    cleaning: yup.number().required(),
    basicCleaning: yup.number().required(),
    tax: yup.number().required(),
    extraFees: yup.array().of(yup.object().shape({
      feeId: yup.string().required(),
      amount: yup.number().required(),
      frequency: yup.string().oneOf(['once', 'nightly']).required(),
      title: yup.string().required(),
      description: yup.string().required(),
    })),
  }),
  public: yup.bool(),
})
